import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ativo", "site", "home"]

  initialize() {
    this.onChange = this.sync.bind(this)
  }

  connect() {
    // O tema global desmarca checkboxes com data-action; ligamos os eventos diretamente.
    this.ativoTarget.addEventListener("change", this.onChange)
    this.siteTarget.addEventListener("change", this.onChange)
    this.updateAvailability()
  }

  disconnect() {
    this.ativoTarget.removeEventListener("change", this.onChange)
    this.siteTarget.removeEventListener("change", this.onChange)
  }

  sync() {
    if (!this.ativoTarget.checked) this.siteTarget.checked = false
    if (!this.siteTarget.checked) this.homeTarget.checked = false

    this.updateAvailability()
  }

  updateAvailability() {
    this.siteTarget.disabled = !this.ativoTarget.checked
    this.homeTarget.disabled = !this.ativoTarget.checked || !this.siteTarget.checked
  }
}
